import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type DashboardPanelEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const dashboardPanelEntryPoint: EntryPoint<DashboardPanelEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<DashboardPanelEntryPointComponent>(
			/* webpackChunkName: "async-servicedesk-proactive-support-dashboard-panel" */ './DashboardPanel.tsx',
		),
		getPreloadProps: () => ({}),
	});
